import React from "react";
import PropTypes from "prop-types";
import { ListItem } from "@op/opds.opux";
import { useMessageGetter } from "react-message-context";
import { INVALID_TEXT_AREA_ERROR_CODE } from "../../utils/enums";
import InvalidError from "./InvalidError";

const ErrorAction = ({ index, error, errorCount }) => {
  const key = error.key;
  const value = error.value;
  const msgs = useMessageGetter("feedback.form");

  const navigate = (fieldName, e) => {
    e.preventDefault();
    let input =
      document.querySelector(`#ROF-${fieldName} input`) ||
      document.querySelector(`#ROF-${fieldName}`);
    if (input) input.focus();
  };

  const resolveErrorMessage = (fieldName, val) => {
    if (val.error.code === INVALID_TEXT_AREA_ERROR_CODE) {
      return <InvalidError noLineBreaks />;
    }

    return msgs(`${fieldName}.error.${val.error.code}`);
  };

  return (
    <ListItem
      key={key}
      onClick={(e) => navigate(key, e)}
      onKeyPress={(e) => navigate(key, e)}
      className="rof-errorSummary__link"
    >
      {errorCount > 1 && `${index + 1}. `}
      {msgs(`${key}.label`)}: {resolveErrorMessage(key, value)}
    </ListItem>
  );
};

ErrorAction.propTypes = {
  index: PropTypes.number.isRequired,
  error: PropTypes.object.isRequired,
  errorCount: PropTypes.number.isRequired,
};

export default ErrorAction;
